// utils
import { axios, getAccessToken } from 'utils'
import { formatExtractedInfoApiResponse } from 'features/calls'

export const getExtractedInfo = async (url: string) => {
  const { data } = await axios.get(url, { headers: { Authorization: getAccessToken() } })
  return formatExtractedInfoApiResponse(data)
}
